import React, { useEffect, useRef } from 'react';
import landing from '../../assets/images/landing.png'
import { FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../store/languageContext';
import translate from '../../utils/translation';
import { motion } from 'framer-motion';
const LandingSection = () => {
    const sectionRef = useRef(null);
    const { language, setNavColor } = useLanguage();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setNavColor('white');
                }
            },
            {
                threshold: 0.1,
                rootMargin: '-50px 0px -20% 0px',
            }
        );

        const currentRef = sectionRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [setNavColor]);
    return (
        <section ref={sectionRef} className="landing-section flex items-end pb-8 sm:pb-[50px] justify-center text-white text-center overflow-hidden relative min-h-[70vh] sm:min-h-[80vh] md:min-h-screen px-4">
            <img src={landing} alt="landing" className="absolute top-0 -translate-y-[5%] left-0 w-full h-full object-cover z-[-1]" />
            <div className="z-[2] w-full max-w-4xl">
                <motion.h1
                    initial={{ y: 100, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2, ease: 'easeOut' }}
                    viewport={{ once: true }}
                    className="text-4xl sm:text-5xl md:text-7xl lg:text-[100px] leading-tight sm:leading-tight md:leading-[1.1] lg:leading-[100px] font-semibold roboto-font">{translate[language]['landingHeader1']} <br /> {translate[language]['landingHeader2']}</motion.h1>
                <motion.p
                    initial={{ y: 50, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.4, ease: 'easeOut' }}
                    viewport={{ once: true }}
                    className="text-base sm:text-lg md:text-xl mt-3 sm:mt-4 max-w-[280px] sm:max-w-[350px] mx-auto">{translate[language]['landingHeader3']}</motion.p>
                <motion.ul
                    initial={{ y: 35, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.6, ease: 'easeOut' }}
                    viewport={{ once: true }}
                    className={`flex flex-col sm:flex-row gap-3 sm:gap-2 mx-auto w-full items-center justify-center mt-5 sm:mt-[20px]`}>
                    <li className='bg-[#eeeeee1f] px-5 py-2.5 sm:px-4 sm:py-3 rounded-full duration-300 cursor-pointer hover:bg-white hover:text-black text-white text-sm sm:text-base w-full sm:w-auto'><a className='flex gap-2 items-center justify-center' href="https://wa.me/+201117169426" target="_blank" rel="noopener noreferrer"><FaWhatsapp />{translate[language]['contactUs']}</a></li>
                    <li className='bg-[#eeeeee1f] px-5 py-2.5 sm:px-4 sm:py-3 rounded-full duration-300 cursor-pointer hover:bg-white hover:text-black text-white text-sm sm:text-base w-full sm:w-auto'><Link to="/products">{translate[language]['products']}</Link></li>
                </motion.ul>
            </div>
        </section>
    )
};

export { LandingSection };